module.exports = Globalize;


//////////////////
// WEBPACK FOOTER
// external "Globalize"
// module id = 620
// module chunks = 0